import { AppThunk } from "store";

import { applicationActions } from "../reducer";

export const setZoom =
  (zoomValue: number): AppThunk =>
  async (dispatch) => {
    dispatch(applicationActions.setZoom(zoomValue));
  };
